import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'calendarFilter', namespaced: true })
export default class CalendarFilter extends FilterModule {
    constructor(module: CalendarFilter) {
        super(module);
    }
}
